export StripedSlider from './modules/striped-slider/StripedSlider.jsx';
export Hero from './modules/hero/Hero.jsx';
